'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import { BgDpcRecipeCategoryType } from '@/data/dtos/Resouces/BgDentalProcedureCodes/BgDpcRecipeCategoryType';

interface DentalTreatmentCatalogFiltrationProps {
	className?: string;
	treatmentCategories: BgDpcRecipeCategoryType[];
	onCategoryChange?: (category: string) => void; // Optional callback for parent notification
}

export default function DentalTreatmentCatalogFiltration({
	treatmentCategories,
	onCategoryChange,
	className = 'form-select',
}: DentalTreatmentCatalogFiltrationProps) {
	const [selectedCategory, setSelectedCategory] = useState('all');
	const t = useTranslations('page.r-bg-dental-procedure-codes-catalog');

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
	const value = e.target.value;
	setSelectedCategory(value);
	if (onCategoryChange) {
		onCategoryChange(value); // Notify parent component if callback provided
	}
	};

	return (
	<select
		className={className}
		aria-label={t('dental-treatments-section.select_all_categories')}
		value={selectedCategory}
		onChange={handleChange}
	>
		<option value="all">{t('dental-treatments-section.select_all_categories')}</option>
		{treatmentCategories.map((category) => (
			<option value={category.slug} key={category.slug}>
				{category.name}
			</option>
		))}
	</select>
	);
}
